module.exports = __webpack_public_path__ + "img/ks.c9bfcca1.png";